/**
 * Shared focus-visible styles for form controls.
 *
 * Uses the `border.focus` semantic token so focus rings follow
 * the company accent color set by admins via theming.
 */
export const outlineFocusVisible = {
	_focusVisible: {
		borderColor: 'border.focus',
		boxShadow: '0 0 0 1px var(--chakra-colors-border-focus)',
	},
};

/**
 * Surface styles for the default `outline` Input/Select variant.
 *
 * Must live on the variant (not `baseStyle`): Chakra’s default outline variant
 * sets `bg`/`borderColor` to `inherit`, and `extendTheme` merges that function
 * with our object override — so baseStyle values lose and dark-mode fields stay
 * transparent against modal panels.
 */
export const outlineFieldSurface = {
	bg: 'bg.surface',
	color: 'text.default',
	borderColor: 'border.default',
};

export const flushedFocusVisible = {
	_focusVisible: {
		borderColor: 'border.focus',
		boxShadow: '0px 1px 0px 0px var(--chakra-colors-border-focus)',
	},
};
